import { render, staticRenderFns } from "./ViewReceiversData.vue?vue&type=template&id=4de371a5&scoped=true&"
import script from "./ViewReceiversData.vue?vue&type=script&lang=ts&"
export * from "./ViewReceiversData.vue?vue&type=script&lang=ts&"
import style0 from "./ViewReceiversData.vue?vue&type=style&index=0&id=4de371a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de371a5",
  null
  
)

export default component.exports